// Shell contract: the top bar renders only feature-agnostic chrome — a back
// button and empty center/right slots. Feature-specific UI must be mounted
// by the feature's own components via TopBarSlot, so the shell never knows
// which features are enabled.

import {ActionIcon, Tooltip} from "@mantine/core";
import {Link, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import IconArrowLeft from "../../../assets/arrow-left.svg?react";
import IconHome from "../../../assets/home-2.svg?react";
import {useTopBarSlots} from "../TopBarContext";
import {useBackNavigation} from "../../../navigation/backNavigation";
import {isDashboardPath} from "../../../paths";
import classes from "./TopBar.module.css";

export const TopBar = () => {
    const location = useLocation();
    const goBack = useBackNavigation();
    const {t} = useTranslation();
    const {setCenterEl, setRightEl} = useTopBarSlots();

    if (isDashboardPath(location.pathname)) {
        // DashboardLayout renders its own toggle inside the sticky top area.
        return null;
    }

    return (
        <div className={classes.topBar} data-icon-count={2}>
            <div className={classes.left}>
                {/* Home anchor: an unconditional fresh start at the front
                    page (a push), deliberately coexisting with the
                    origin-aware back button — the two overlap in destination
                    only when the previous place is the front page itself. */}
                <Tooltip label={t("common.goHome", {defaultValue: "Home"})}>
                    <ActionIcon
                        component={Link}
                        to="/"
                        size="lg"
                        radius="xl"
                        variant="subtle"
                        color="gneis"
                        title={t("common.goHome", {defaultValue: "Home"})}
                        className={classes.iconButton}
                    >
                        <IconHome width={20} />
                    </ActionIcon>
                </Tooltip>
                <Tooltip label={t("common.goBack")}>
                    <ActionIcon
                        size="lg"
                        radius="xl"
                        variant="subtle"
                        color="gneis"
                        title={t("common.goBack")}
                        onClick={goBack}
                        className={classes.iconButton}
                    >
                        <IconArrowLeft width={20} />
                    </ActionIcon>
                </Tooltip>
            </div>
            <div className={classes.constrainer}>
                <div ref={setCenterEl} className={classes.center} />
            </div>
            <div ref={setRightEl} className={classes.right} />
        </div>
    );
};
